import React from "react";
import ProgramCard from "./ProgramCard";

function ProgramGrid({ programs }) {
    return (
        <div className="container program-grid-section">
            <div className="row justify-content-center g-4">
                {programs.map((program) => (
                    <div
                        key={program.id}
                        className="col-12 col-md-6 col-xl-4 d-flex justify-content-center"
                    >
                        <ProgramCard program={program} />
                    </div>
                ))}
            </div>
        </div>
    );
}

export default ProgramGrid;